import { IPaidPayment } from "../domain/IPaidPayment";
import { useAppDispatch } from "hooks/hooks";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getPartnerPayablesWithPayments,
  selectState,
} from "../slices/dtPayables.slice";
import Loader from "components/Loader/Loader";
import { FormatNumberWithUnitOrNull } from "utils/numberUtils";
import InfoTooltip from "components/Popup/InfoTooltip";
import { FormatDateShort } from "utils/dateUtils";

export const WePaidPreview = () => {
  const { remainingPayableAmount, paidPayments, loading } =
    useSelector(selectState);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getPartnerPayablesWithPayments());
  }, [dispatch]);

  return (
    <div className="daily-table-payables loading-container">
      {loading && <Loader />}
      <div className="previewHeader bolded">MI PLATILI</div>
      <div className="paidPreview">
        <div className="paidHeader">
          <span className="daily-table-invoices-total-label">dugujemo suma</span>
          <span className="daily-table-invoices-total-amount">{FormatNumberWithUnitOrNull(remainingPayableAmount, 'rsd')}</span>
        </div>
        <div className="wePaidBody">
          {paidPayments.map((payment: IPaidPayment) => (
            <div className="singlePaid">
              <InfoTooltip
                tooltip={payment.partnerName}
                classesProp="daily-table-invoices-item-name text-overflow"
                element="span"
              >
                {payment.partnerName}
              </InfoTooltip>
              <span className="daily-table-invoices-item-amount">{FormatNumberWithUnitOrNull(payment.amount, 'rsd')}</span>
              <span className="daily-table-invoices-item-date">{FormatDateShort(payment.date)}</span>
            </div>
          ))}
          {paidPayments.length < 9 && <div className="singlePaid"></div>}
          {paidPayments.length < 8 && <div className="singlePaid"></div>}
          {paidPayments.length < 7 && <div className="singlePaid"></div>}
          {paidPayments.length < 6 && <div className="singlePaid"></div>}
          {paidPayments.length < 5 && <div className="singlePaid"></div>}
          {paidPayments.length < 4 && <div className="singlePaid"></div>}
          {paidPayments.length < 3 && <div className="singlePaid"></div>}
          {paidPayments.length < 2 && <div className="singlePaid"></div>}
          {paidPayments.length < 1 && <div className="singlePaid"></div>}
        </div>
      </div>
    </div>
  );
};
